import { query } from "js-query-builder";
import qs from "qs";

const queryBuilder = (url, { fields = [], include = [], append = [], limit = 0, sort = "", filter = {}, page = 1, extra = {} } = {}) => {

	let queryObj = query(url);

	if(fields.length){
		queryObj.param("fields", fields);
	}

	if(include.length){
		queryObj.include(include);
	}

	if(append.length){
		queryObj.append(append);
	}
	if(limit > 0){
		queryObj.param("per_page", Number(limit));
	}

	if(sort){
		queryObj.sort(sort);
	}

	const arrayFilterParams = [];

	if(Object.keys(filter).length){
		Object.keys(filter).forEach(key => {
			const value = filter[key];
			if(Array.isArray(value)){
				value.forEach(item => {
					if(item !== undefined && item !== null && item !== ""){
						arrayFilterParams.push(`filter[${encodeURIComponent(key)}][]=${encodeURIComponent(item)}`);
					}
				});
			} else {
				const normalized = qs.stringify({ filter: { [key]: value } }, { encode: false }).split("&");
				normalized.forEach(item => {
					const splited = item.split("=");
					if(splited.length === 2 && splited[0] && splited[1] !== ""){
						queryObj.param(splited[0], splited[1]);
					}
				});
			}
		});
	}

	const arrayExtraParams = [];

	if(Object.keys(extra).length){
		Object.keys(extra).forEach(key => {
			const value = extra[key];
			if(
				key &&
				value !== undefined &&
				value !== null &&
				value !== "" &&
				value !== false
			){
				if(Array.isArray(value)){
					value.forEach(item => {
						if(item !== undefined && item !== null && item !== ""){
							arrayExtraParams.push(`${encodeURIComponent(key)}[]=${encodeURIComponent(item)}`);
						}
					});
				} else {
					queryObj.param(key, value);
				}
			}
		});
	}

	if(page > 1){
		queryObj.page(Number(page));
	}

	let built = queryObj.build();
	const appendParams = [...arrayFilterParams, ...arrayExtraParams];
	if(appendParams.length){
		built += (built.includes("?") ? "&" : "?") + appendParams.join("&");
	}

	return decodeURIComponent(built);
};

export default queryBuilder;
